module.exports = __webpack_public_path__ + "static/media/br-df.4ba5fdf0.svg";